import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import PageLoader from '../../layout/components/PageLoader.jsx';
import http from '../../config/http.js';
import { AUTH_POST_LOGOUT_URL } from '../../config/api.js';
import { devLog, isDevelopment, localLogout } from '../../utils/dev.js';

function Logout() {
  const [loading, setLoading] = useState(true);
  const logoutUser = async () => {
    try {
      await http.post(AUTH_POST_LOGOUT_URL);
    } catch (e) {
      devLog(e);
    } finally {
      !isDevelopment() || localLogout();
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
      if (window?.heap?.identify) {
        window.heap.identify(null);
      }
      setLoading(false);
    }
  };
  useEffect(() => {
    logoutUser();
  }, []);

  if (!loading) {
    return <Redirect to="/login" />;
  }

  return <PageLoader />;
}

export default Logout;
